module.exports = __webpack_public_path__ + "static/nihal-ea5b5a5bb75450d8cad87ca1b78afb2e.jpeg";